var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoriesLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.666992C30.6775 0.666992 39.333 9.3225 39.333 20C39.333 30.6775 30.6775 39.333 20 39.333C9.3225 39.333 0.666992 30.6775 0.666992 20C0.666992 9.3225 9.3225 0.666992 20 0.666992Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.666992C30.6775 0.666992 39.333 9.3225 39.333 20C39.333 30.6775 30.6775 39.333 20 39.333C9.3225 39.333 0.666992 30.6775 0.666992 20C0.666992 9.3225 9.3225 0.666992 20 0.666992Z",
    stroke: "#383838",
    strokeWidth: 1.33333
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5342_225073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7712 10.9131C26.2917 10.9132 27.6825 11.5197 28.698 12.6211C29.7035 13.7118 30.2703 15.2164 30.2703 16.8701C30.2702 18.5435 29.6542 20.0996 28.2507 21.793C26.9784 23.3283 25.1382 24.8983 22.948 26.7646C22.2042 27.3986 21.3576 28.1196 20.4792 28.8877C20.3471 29.0034 20.1767 29.0674 19.9998 29.0674C19.8672 29.0673 19.7386 29.0317 19.6267 28.9648L19.5203 28.8877C18.6419 28.1197 17.796 27.3984 17.0525 26.7646C14.862 24.898 13.0221 23.3282 11.7498 21.793C10.3462 20.0993 9.73025 18.5434 9.73022 16.8701C9.73022 15.2163 10.2962 13.7118 11.3015 12.6211C12.3171 11.5196 13.7086 10.9131 15.2292 10.9131C16.3552 10.9131 17.3823 11.2663 18.2957 11.9727C18.7595 12.3314 19.1847 12.7738 19.5623 13.2959L19.9998 13.9014L20.4382 13.2959C20.8159 12.7737 21.2402 12.3313 21.7039 11.9727C22.6174 11.2662 23.6453 10.9131 24.7712 10.9131Z",
    stroke: "white",
    strokeWidth: 1.08108
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5342_225073"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.6216,
    height: 21.6216,
    fill: "white",
    transform: "translate(9.18921 9.18945)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoriesLike);
export default __webpack_public_path__ + "static/media/stories-like.239b62d4810c32ae55b6438438055273.svg";
export { ForwardRef as ReactComponent };